module.exports = __webpack_public_path__ + "img/244.room_conditions.e367f63d.svg";